// extracted by mini-css-extract-plugin
export default {"day":"DailyForecast_day__NOdbE","day__name":"DailyForecast_day__name__wqi1Q"};